import ReactDOM from "react-dom/client";

const ALERT_CONTAINER_ID = "alert-container";

export const Alert = (text: string, onDismiss?: () => void): void => {
  // Singleton guard: don't stack alerts on top of each other.
  if (document.getElementById(ALERT_CONTAINER_ID)) return;

  // Render the component
  const appContainer =
    document.getElementById("app-container") || document.body;
  const container = document.createElement("div");
  container.id = ALERT_CONTAINER_ID;
  appContainer.appendChild(container);

  const root = ReactDOM.createRoot(container);

  // Destroy the component and call callback
  const handleClick = () => {
    root.unmount();
    container.remove();
    onDismiss?.();
  };

  const component = (
    <div
      className="fixed top-0 left-0 w-full h-full bg-black/50 backdrop-blur-[3px] z-50 flex items-center justify-center"
      onClick={handleClick}
    >
      <div className="flex flex-col gap-2 w-full bg-pk-black/80 backdrop-blur-[3px] relative">
        <div className="mx-auto p-4 rounded-lg">
          <h2 className="font-bold">{text}</h2>
        </div>

        <span className="text-xs w-max absolute bottom-[-40px] left-1/2 -translate-x-1/2  text-white/80">
          Click anywhere to proceed
        </span>
      </div>
    </div>
  );

  root.render(component);
};
